<template>
  <div 
    class="wiki-image"
  >
    <b-img
        v-if="commonsImage"
        :src="commonsImage" fluid alt="Responsive image">
    </b-img>
    <b-img
        v-else
        src="/img/wiki-portrait-placeholder.jpg" fluid alt="Responsive image">
    </b-img>
    <p
      v-if="imageSource && commonsImage"
      class="small mt-1"
    >
      <b-link
        :href="`${imageSource}`"
        alt="link to image source"
        target="_blank"
      >
        Quelle
      </b-link>
    </p>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
// import axios from 'axios'

export default {
  name: 'wiki-image',
  props: {
      imageSource: String,
      commonsImage: String
  },
  components: {
     
  },
  data () {
      return {
        
      }
  },
  methods: {
    ...mapActions({
        
    }),
    fetchData () {
        
    }
  },
  computed: {
    ...mapGetters({
      
    })
  },
  created () {
    this.fetchData()
  }
}
</script>
<style scoped>
    .wiki-image {
        
    }
</style>
